"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";

import moment from "moment";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { Glyphicon } from 'react-bootstrap';
import Img from 'react-image';

import ReactTable from "react-table";
import "react-table/react-table.css";

import Row from "../../Layout/Row";
import Col from "../../Layout/Col";
import Box from "../../Widget/Box";
import ExpandableBox from "../../Widget/ExpandableBox";
import Callout from "../../Widget/Callout";

import { NumberFormat } from "../../Util/NumberFormat"

import {apiPath, platformFromId, timeCodeLabelFromType} from "../../../const";
import {getRequest, postRequest} from "../../../service/api/request";
import {withAlert} from "react-alert";

const EnrichedVideoWidget = withAlert(class  EnrichedVideoWidget extends Component {

    static propTypes = {
        enrichedVideoId: PropTypes.string,
        enrichedVideo: PropTypes.object,
        defaultVideoEnrichmentEventPageSize: PropTypes.number,
        defaultVideoEnrichmentEventSorted: PropTypes.array,
        defaultVideoEnrichmentEventSortDesc: PropTypes.bool,
        subscriptionPackageNameByVideoPackageId: PropTypes.arrayOf(
            PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.string, PropTypes.any])
            )
        ),
    };

    static defaultProps = {
        defaultVideoEnrichmentEventPageSize: 20,
        defaultVideoEnrichmentEventSorted: [{id: "timestamp", desc: true}],
        defaultVideoEnrichmentEventSortDesc: true,
    };

    constructor(props) {
        super(props);
        this.state = {
            subscriptionPackageNameByVideoPackageId: [],
            videoEnrichmentEventData: {},
            videoEnrichmentEventsFiltered: [],
            subscriptionPackageLoading: true,
            videoEnrichmentEventDataLoading: true,
            videoAssetFileMetaData: {},
            videoAssetFileMetaDataLoading: true,
            videoAssetProvisioningMetaData: {},
            videoAssetProvisioningMetaDataLoading: true,
        };

        this.onRevalidateClick = this.onRevalidateClick.bind(this);
        this.onReprocessClick = this.onReprocessClick.bind(this);
        this.renderApiResponse = this.renderApiResponse.bind(this);
    }

    componentDidMount() {
        this.fetchVideoEnrichmentEventData();
        this.fetchVideoAssetFileMetaData();
        this.fetchVideoAssetProvisioningMetaData();
        this.fetchSubscriptionPackageNameByVideoPackageId();
        $('.tooltipped').tooltip();
    }

    fetchSubscriptionPackageNameByVideoPackageId() {
        this.setState({ subscriptionPackageLoading: true });

        getRequest( apiPath + "/subscriptionPackageNameByVideoPackageId",{})
            .then(response => {
                this.setState({
                    subscriptionPackageNameByVideoPackageId: Object.entries(response.entity)
                });
                $('.lazy-loaded .tooltipped').tooltip();
            }).finally(() => this.setState({subscriptionPackageLoading: false}));
    }

    fetchVideoEnrichmentEventData() {
        this.setState({ videoEnrichmentEventDataLoading: true });

        const reportApiPath = apiPath + "/videoEnrichmentEvents/search/findEnrichedVideoVideoEnrichmentEventReport";
        let params = {};
        params.enrichedVideoId = this.props.enrichedVideoId;
        params.sort = "timestamp,desc";

        getRequest(
            reportApiPath,
            params
        )
        .then(response => {
            this.setState({
                videoEnrichmentEventData: response.entity,
            });
            $('.lazy-loaded .tooltipped').tooltip();
        })
        .finally(() => this.setState({videoEnrichmentEventDataLoading: false}));
    }

    fetchVideoAssetFileMetaData() {
        this.setState({ videoAssetFileMetaDataLoading: true });

        const reportApiPath = apiPath + "/enrichedVideos/videoAssetFileMetaData";
        let params = {};
        params.enrichedVideoId = this.props.enrichedVideoId;

        getRequest(
            reportApiPath,
            params
        ).then(response => {
            this.setState({
                videoAssetFileMetaData: response.entity,
            });
            $('.lazy-loaded .tooltipped').tooltip();
        }).finally(() => this.setState({videoAssetFileMetaDataLoading: false}));
    }

    fetchVideoAssetProvisioningMetaData() {
        this.setState({ videoAssetProvisioningMetaDataLoading: true });

        const reportApiPath = apiPath + "/enrichedVideos/videoAssetProvisioningMetaData";
        let params = {};
        params.enrichedVideoId = this.props.enrichedVideoId;

        getRequest(
            reportApiPath,
            params
        ).then(response => {
            this.setState({
                videoAssetProvisioningMetaData: response.entity,
            });
            $('.lazy-loaded .tooltipped').tooltip();
        }).finally(() => this.setState({videoAssetProvisioningMetaDataLoading: false}));
    }

    render() {
        const {enrichedVideoId, enrichedVideo} = this.props;
        const {videoEnrichmentEventData, videoEnrichmentEventsFiltered, videoEnrichmentEventDataLoading} = this.state;
        const {videoAssetFileMetaData, videoAssetFileMetaDataLoading} = this.state;
        const {videoAssetProvisioningMetaData, videoAssetProvisioningMetaDataLoading} = this.state;
        const {subscriptionPackageNameByVideoPackageId, subscriptionPackageLoading} = this.state;

        function videoPackageFromId(videoPackageId) {
            let videoPackageName = subscriptionPackageNameByVideoPackageId.find(([key]) => key === videoPackageId);
            return videoPackageName ? videoPackageName[1] : "";
        }
        return (

            <div>
                <Row>
                    <Col md="12" sm="12" xs="12">
                        {this.renderViolationsBox(enrichedVideo)}
                    </Col>
                </Row>
                <Row>
                    <Col md="7" sm="12" xs="12">
                        {this.renderAuditBox(enrichedVideo, videoEnrichmentEventData)}
                    </Col>
                    <Col md="5" sm="12" xs="12">
                        {this.renderReferencesBox(enrichedVideo)}
                    </Col>
                </Row>
                <Row>
                    <Col md="7" sm="12" xs="12">
                        {this.renderVideoInformationBox(enrichedVideo)}
                    </Col>
                    <Col md="5" sm="12" xs="12">
                        {this.renderVideoImagesBox(enrichedVideo)}
                    </Col>
                </Row>
                { enrichedVideo.program &&
                  <Row>
                      <Col md="7" sm="12" xs="12">
                          {this.renderProgramInformationBox(enrichedVideo)}
                      </Col>
                      <Col md="5" sm="12" xs="12">
                          {this.renderProgramImagesBox(enrichedVideo)}
                      </Col>
                  </Row> }
                { enrichedVideo.season &&
                    <Row>
                        <Col md="7" sm="12" xs="12">
                            {this.renderSeasonInformationBox(enrichedVideo)}
                        </Col>
                        <Col md="5" sm="12" xs="12">
                            {this.renderSeasonImagesBox(enrichedVideo)}
                        </Col>
                    </Row> }
                <Row>
                    <Col md="7" sm="12" xs="12">
                        {this.renderSchedulingBox(enrichedVideo,videoPackageFromId)}
                        {this.renderVideoEnrichmentEventBox(videoEnrichmentEventData.videoEnrichmentEvents,
                                                            videoEnrichmentEventsFiltered,
                                                            videoEnrichmentEventDataLoading)}
                    </Col>
                    <Col md="5" sm="12" xs="12">
                        {this.renderVideoAssetsBox(enrichedVideo,
                                                   videoAssetFileMetaData,
                                                   videoAssetFileMetaDataLoading,
                                                   videoAssetProvisioningMetaData,
                                                   videoAssetProvisioningMetaDataLoading)}
                    </Col>
                </Row>
            </div>
        )
    }

    renderAuditBox(enrichedVideo, videoEnrichmentEventData) {
        return <Box content={
                    <div>
                    <Row>
                        <Col sm="4" xs="12">
                            <div><strong>{"Created"}</strong> <p>{this.formattedLocalDateTime(enrichedVideo.createdDate)}</p></div>
                        </Col>
                        <Col sm="4" xs="12">
                            <div><strong>{"Last Modified"}</strong> <p>{this.formattedLocalDateTime(enrichedVideo.lastModifiedDate)}</p></div>
                        </Col>
                        <Col sm="4" xs="12">
                            <button className="btn btn-block btn-danger"
                                    onClick={this.onRevalidateClick}>
                                <FontAwesomeIcon icon="redo"/>
                                <strong>  Revalidate</strong>
                            </button>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="4" xs="12">
                            <div>
                                <strong>{"Aired"}</strong>
                                <p>{this.formattedLocalDateTime(enrichedVideo.airDate)}</p>
                            </div>
                        </Col>
                        <Col sm="4" xs="12">
                            <div>
                                <strong>{"First Data Event"}</strong>
                                <p>{this.humanizedTimeSpent(enrichedVideo.airDate,
                                                            videoEnrichmentEventData.firstDataEventReceived)}</p>
                            </div>
                        </Col>
                        <Col sm="4" xs="12">
                            <div>
                                <strong>{"First Complete Data Event"}</strong>
                                <p>{this.humanizedTimeSpent(enrichedVideo.airDate,
                                                            videoEnrichmentEventData.firstCompleteDataEventReceived)}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="4" xs="12">
                            <div>
                                <strong>{"First Complete Data Event"}</strong>
                                <p>{this.formattedLocalDateTime(videoEnrichmentEventData.firstCompleteDataEventReceived)}</p>
                            </div>
                        </Col>
                        <Col sm="4" xs="12">
                            <div>
                                <strong>{"First Complete Validation"}</strong>
                                <p>{this.humanizedTimeSpent(videoEnrichmentEventData.firstCompleteDataEventReceived,
                                                            videoEnrichmentEventData.firstCompleteValidating)}</p>
                            </div>
                        </Col>
                        <Col sm="4" xs="12">
                            <div>
                                <strong>{"First Catalogue Availability"}</strong>
                                <p>{this.humanizedTimeSpent(videoEnrichmentEventData.firstCompleteDataEventReceived,
                                                            videoEnrichmentEventData.firstCompleteAvailability)}</p>
                            </div>
                        </Col>
                    </Row>
                    </div>
                    }/>;
    }

    formattedLocalDateTime(dateTime) {
        return (dateTime && moment(dateTime).local().format("YYYY-MM-DD HH:mm:ss")) || "Not Available";
    }

    humanizedTimeSpent(start, end) {
        return (start && end && this.durationHumanized(moment.duration(moment(end).diff(moment(start))))) ||
               (!start && "Not Available") ||
               "Never";
    }

    durationHumanized(duration) {
        let durationComponents = [];
        let seconds = duration.asSeconds();
        let prefix = (seconds >= 0) ? "in " : "";
        let suffix = (seconds < 0) ? " before" : "";
        seconds = Math.abs(seconds);
        let daySeconds = 86400;
        let hourSeconds = 3600;
        let minuteSeconds = 60;

        if (seconds >= (2 * daySeconds))
            durationComponents.push("" + Math.floor(seconds / daySeconds) + " days");
        else if (seconds >= daySeconds)
            durationComponents.push("a day");

        let remainderDaySeconds = (seconds % daySeconds);
        if (remainderDaySeconds >= (2 * hourSeconds))
            durationComponents.push("" + Math.floor(remainderDaySeconds/hourSeconds) + " hours");
        else if (remainderDaySeconds >= hourSeconds)
            durationComponents.push("an hour");

        let remainderHourSeconds = (remainderDaySeconds % hourSeconds);
        durationComponents.push("" + Math.ceil(remainderHourSeconds / minuteSeconds) + " minutes");

        return prefix + durationComponents.join(" and ") + suffix;
    }

    onRevalidateClick(e) {
        const {enrichedVideoId} = this.props;

        const revalidateApiPath = apiPath + "/enrichedVideos/revalidate";

        postRequest(
            revalidateApiPath,
            {id:enrichedVideoId},
        ).then(response => {
           response && this.props.alert.success(this.renderApiResponse(response.entity), {offset:"100px", timeout:60000});
        }).catch(response => {
            response && this.props.alert.error(`HTTP ${response.entity.status} - ${response.entity.error} : ${response.entity.message}`,
                                               {offset:"100px", timeout:3000});
        });

    }

    onReprocessClick(e) {
        const {enrichedVideoId} = this.props;

        const reprocessApiPath = apiPath + "/enrichedVideos/reprocess";

        postRequest(
            reprocessApiPath,
            {id:enrichedVideoId},
        ).then(response => {
            response && this.props.alert.success(this.renderApiResponse(response.entity), {offset:"100px", timeout:60000});
        }).catch(response => {
            response && this.props.alert.error(`HTTP ${response.entity.status} - ${response.entity.error} : ${response.entity.message}`,
                {offset:"100px", timeout:3000});
        });

    }

    renderApiResponse(response) {
        return response &&
               <div>
                   <ul>
                   {response.map(message =>
                        <li>
                            {message}
                        </li>
                   )}
                   </ul>
               </div>
    }

    renderViolationsBox(enrichedVideo) {
        return enrichedVideo && enrichedVideo.violations && enrichedVideo.violations.length > 0 &&
               <ExpandableBox
                   icon="exclamation-triangle"
                   header="Violations"
                   content={
                       <Violations violations={enrichedVideo.violations}/>
                   }/>
    }

    renderReferencesBox(enrichedVideo) {
        return <Box icon="link"
                    header="References"
                    content={
                        <dl className="dl-horizontal">
                            <dt>Slug</dt><dd>{enrichedVideo.slug}</dd>
                            <dt>Gen. Ref.</dt><dd>{enrichedVideo.externalReference.genRef}</dd>
                            <dt>UID</dt><dd>{enrichedVideo.externalReference.uid}</dd>
                            <dt>Region Code</dt><dd>{enrichedVideo.externalReference.regionCode}</dd>
                            <dt>Stack Id</dt><dd>{enrichedVideo.externalReference.stackId}</dd>
                        </dl>
                    }
               />
    }

    renderVideoInformationBox(enrichedVideo) {
        return <Box icon="film"
                    header="Video Information"
                    content={
                        <div>
                            <h3 className="mt0 mb4">{enrichedVideo.title} <small>{enrichedVideo.type}</small></h3>
                            <div className="mb4"><Categorisations categorisations={enrichedVideo.categorisations}/></div>
                            <p className="mb4">{enrichedVideo.synopsis}</p>
                            { this.renderGenreAndTagsInformation(enrichedVideo.genres, enrichedVideo.tags, enrichedVideo.flags) }
                            <div className="mb2">
                                <div className="pull-left mb2">
                                    { enrichedVideo.yearOfRelease !== 0 &&
                                      <span className="badge bg-blue">{enrichedVideo.yearOfRelease}</span> }
                                    { enrichedVideo.durationInSeconds &&
                                      <span className="badge bg-blue">{moment.utc(enrichedVideo.durationInSeconds*1000).format('HH:mm:ss')}</span> }
                                </div>
                                <div className="pull-right mb2">
                                    { enrichedVideo.restrictionRating && enrichedVideo.restrictionRating.ageRestrictedToAge &&
                                      <span className="badge bg-blue">{enrichedVideo.restrictionRating.ageRestrictedToAge}</span> }
                                    { enrichedVideo.ratingAdvisory &&
                                      <span className="badge bg-blue">{enrichedVideo.ratingAdvisory}</span> }
                                </div>
                            </div>
                        </div>
                    }
                    />
    }

    renderVideoImagesBox(enrichedVideo) {
        return <Box icon="file-image"
                    header="Video Images"
                    content={
                        <Images images={enrichedVideo.images}
                                requiredImageMap={
                                    enrichedVideo.program
                                    ? { "poster":["MEDIUM", "LARGE"], "poster-landscape":["MEDIUM", "LARGE"], "portrait-iconic":["MEDIUM", "LARGE"], "hero":["MEDIUM", "LARGE"], "square-iconic":["MEDIUM", "LARGE"], "show-logo":["XLARGE"], "play-image":["LARGE"], }
                                    : { "poster":["MEDIUM", "LARGE"], "poster-landscape":["MEDIUM", "LARGE"], "portrait-iconic":["MEDIUM", "LARGE"], "hero":["MEDIUM", "LARGE"], "square-iconic":["MEDIUM", "LARGE"], "show-logo":["XLARGE"], "play-image":["LARGE"], }
                                }
                                />
                    }
                    />
    }

    renderProgramInformationBox(enrichedVideo) {
        return <Box icon="film"
                    header="Program Information"
                    content={
                        <div>
                            <h3 className="mt0 mb4">{enrichedVideo.program.title} <small>{`S ${enrichedVideo.seasonNumber} E ${enrichedVideo.episode}`}</small></h3>
                            <div className="mb4"><Categorisations categorisations={enrichedVideo.program.categorisations}/></div>
                            <p className="mb4">{enrichedVideo.program.synopsis}</p>
                            { this.renderGenreAndTagsInformation(enrichedVideo.program.genres, enrichedVideo.program.tags, enrichedVideo.program.flags) }
                            <dl className="dl-horizontal">
                                {/*<dt>Id</dt><dd>{enrichedVideo.program._id}</dd>*/}
                                <dt>Group Name</dt><dd>{enrichedVideo.program.groupName}</dd>
                                <dt>Series Id</dt><dd>{enrichedVideo.program.seriesId}</dd>
                                <dt>Season Id</dt><dd>{enrichedVideo.seasonId}</dd>
                            </dl>
                        </div>
                    }
                    />
    }

    renderProgramImagesBox(enrichedVideo) {
        return <Box icon="file-image"
                    header="Program Images"
                    content={
                        <Images images={enrichedVideo.program.images}
                                requiredImageMap={
                                    enrichedVideo.program
                                        ? { "poster":["MEDIUM", "LARGE"], "poster-landscape":["MEDIUM", "LARGE"], "portrait-iconic":["MEDIUM", "LARGE"], "hero":["MEDIUM", "LARGE"], "square-iconic":["MEDIUM", "LARGE"], "show-logo":["XLARGE"],}
                                        : {  }
                                }
                        />
                    }
                    />
    }

    renderSeasonInformationBox(enrichedVideo) {
        return <Box icon="film"
                    header="Season Information"
                    content={
                        <div>
                            <h3 className="mt0 mb4">{enrichedVideo.season.title} <small>E {enrichedVideo.episode}</small></h3>
                            <p className="mb4">{enrichedVideo.season.synopsis}</p>
                            <dl className="dl-horizontal">
                                <dt>Season Number</dt>
                                <dd>{enrichedVideo.seasonNumber}</dd>
                                <dt>Season Id</dt>
                                <dd>{enrichedVideo.seasonId}</dd>
                                <dt>Total no.of episodes</dt>
                                <dd>{enrichedVideo.season.totalNumberOfEpisodes}</dd>
                            </dl>
                        </div>
                    }
        />
    }

    renderSeasonImagesBox(enrichedVideo) {
        return <Box icon="file-image"
                    header="Season Images"
                    content={
                        <Images images={enrichedVideo.season.images}
                                requiredImageMap={
                                    enrichedVideo.season
                                        ? { "poster":["MEDIUM", "LARGE"], "poster-landscape":["MEDIUM", "LARGE"], "portrait-iconic":["MEDIUM", "LARGE"], "hero":["MEDIUM", "LARGE"], "square-iconic":["MEDIUM", "LARGE"], "show-logo":["XLARGE"],}
                                        : {  }
                                }
                        />
                    }
        />
    }

    renderSchedulingBox(enrichedVideo, videoPackageFromId) {
        const {enrichedVideoId} = this.props;
        return <Box icon="calendar"
                    header="Scheduling"
                    content={
                        <div>
                            <Scheduling enrichedVideoId={enrichedVideoId} enrichedVideo={enrichedVideo} videoPackageFromId={videoPackageFromId} />
                        </div>
                    }
                    />
    }

    renderVideoAssetsBox(enrichedVideo, videoAssetFileMetaData, videoAssetFileMetaDataLoading, videoAssetProvisioningMetaData, videoAssetProvisioningMetaDataLoading) {
        const {enrichedVideoId} = this.props;
        return enrichedVideo && enrichedVideo.videoAssets &&
            <Box icon="file-video"
                 header="Video Assets"
                 content={
                     <div>
                         <VideoAssets enrichedVideoId={enrichedVideoId}
                                      enrichedVideo={enrichedVideo}
                                      videoAssets={enrichedVideo.videoAssets}
                                      videoAssetFileMetaData={videoAssetFileMetaData.metaDataByManItemId}
                                      videoAssetProvisioningMetaData={videoAssetProvisioningMetaData.metaDataByManItemId}
                         />
                         <Row>
                             <Col sm="12" xs="12">
                                 <button className="btn btn-block btn-danger"
                                         onClick={this.onReprocessClick}>
                                     <FontAwesomeIcon icon="redo"/>
                                     <strong>  Reprocess</strong>
                                 </button>
                             </Col>
                         </Row>
                     </div>
                 } />
    }

    renderVideoEnrichmentEventBox(data, filtered, loading) {
        return <Box icon="star"
                    header="Video Enrichment Events"
                    content={
                        <div className="lazy-loaded">
                            <ReactTable
                                columns={[
                                    {
                                        Header: "Module",
                                        accessor: "moduleLabel",
                                    },
                                    {
                                        Header: "Event",
                                        accessor: "eventLabel",
                                    },
                                    {
                                        Header: "Message",
                                        accessor: "message",
                                        Cell: d => (
                                            d.value &&
                                            <span className="tooltipped"
                                                  data-toggle="tooltip"
                                                  data-placement="left"
                                                  title={`${d.value}`}>
                                                {d.value}
                                            </span>
                                        ),
                                    },
                                    {
                                        Header: "Timestamp",
                                        id: "timestamp",
                                        accessor: d => moment(d.timestamp).local().format("YYYY-MM-DD HH:mm:ss.SSS"),
                                    },
                                ]}
                                data={data}
                                filterable
                                defaultFilterMethod={(filter, row) => {
                                    console.log(filter);
                                    return String(row[filter.id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
                                }}
                                className="-striped -highlight"
                                style={{
                                    height: "450px",
                                }}
                            />
                        </div>
                    }
        />
    }

    renderGenreAndTagsInformation(genres, tags, flags) {
        return (genres || tags || flags) &&
            <div className="mb4">
                {
                    genres &&
                    <Row>
                        { genres.group && <Col sm="2" xs="12"><span className="badge bg-green mb2">{genres.group}</span></Col> }
                        { genres.primary && <Col sm="2" xs="12"><span className="badge bg-orange mb2">{genres.primary}</span></Col> }
                        { genres.secondary && <Col sm="2" xs="12"><span className="badge bg-red mb2">{genres.secondary}</span></Col> }
                        { genres.tertiary && <Col sm="3" xs="12">{ genres.tertiary.map(tag => <span key={tag} className="badge bg-blue mb2">{tag}</span>) }</Col> }
                        { genres.tags && <Col sm="3" xs="12">{ genres.tags.map(tag => <span key={tag} className="badge bg-purple mb2">{tag}</span>) }</Col> }
                    </Row>
                }
                {
                    tags &&
                    <Row>
                        <Col sm="12" xs="12">
                            { tags && tags.map(tag => <span key={tag} className="badge bg-teal mb2">{tag}</span>) }
                        </Col>
                    </Row>
                }
                {
                    flags &&
                    <Row>
                        <Col sm="12" xs="12">
                            { flags && flags.map(flag => <span key={flag} className="badge bg-aqua mb2">{flag}</span>) }
                        </Col>
                    </Row>
                }
            </div>
    }
});

class Categorisations extends Component {

    static propTypes = {
        categorisations: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { categorisations } = this.props;

        return (
            <div>
                {categorisations.map(categorisation => {
                    return <span key={`${categorisation.categoryName} / ${categorisation.subCategoryName}`}
                                 className="badge bg-blue">{`${categorisation.categoryName} / ${categorisation.subCategoryName}`}</span>
                })}
            </div>
        )
    }
}

class Images extends Component {

    static propTypes = {
        images: PropTypes.object.isRequired,
        requiredImageMap: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {images, requiredImageMap} = this.props;
        return (
            <div className="mt-2">
                {Object.keys(requiredImageMap).map((key, idx) => {
                    let requiredImageSizes = requiredImageMap[key];
                    let colWidth = 12 / requiredImageSizes.length;
                    return (
                        <div key={key}>
                            <Col sm="3" xs="12">
                                <Row>
                                    <Col sm="12" xs="12">
                                        <Row>
                                            <h3 className="mt3">{key}</h3>
                                                {requiredImageSizes.map(size => {
                                                    return (
                                                        <Col key={`${key}_${size}`} className="text-center" sm={`${colWidth || 6}`} xs="12">
                                                            <h4 className="mt0">{size}</h4>
                                                            {this.renderImage(images, key, size)}
                                                        </Col>
                                                    )
                                                })}
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            { ((idx + 1) % 4 == 0) && <br style={{clear:"both"}} /> }
                        </div>
                    )
                })}
            </div>
        )
    }

    renderImage(images, key, size) {
        return !images || !images[key] || !images[key][size]
               ? this.notLinked(key, size)
               : <div className={`${key}-container`}>
                     <a key={key ? `${key}-a` : null} rel="noopener noreferrer" target="_blank" href={`${apiPath}/cdnImageResolver?cdnImagePath=${images[key][size]}`}>
                         <Img src={`${apiPath}/cdnImageResolver?cdnImagePath=${images[key][size]}`}
                              unloader={this.notFound(`${apiPath}/cdnImageResolver?cdnImagePath=${images[key][size]}`)}
                              className={`${key} img-responsive bg-black`}
                         />
                     </a>
                 </div>
    }

    notLinked(key, size) {
        return <div className="tooltipped text-red" data-toggle="tooltip" title={`No ${size} ${key} image linked.`} style={{backgroundColor:"white"}}>
                   <FontAwesomeIcon icon="times-circle" size="5x" style={{width:"100%"}} />
               </div>
    }

    notFound(src) {
        return <a rel="noopener noreferrer" target="_blank" href={src}>
                   <div className="tooltipped text-red" data-toggle="tooltip" title={`Error loading ${src}`} style={{backgroundColor:"white"}}>
                       <FontAwesomeIcon icon="unlink" size="5x" style={{width:"100%"}} />
                   </div>
               </a>
    }
}

const Scheduling = withAlert(class Scheduling extends Component {

    static propTypes = {
        enrichedVideoId: PropTypes.string.isRequired,
        enrichedVideo: PropTypes.object.isRequired,
        videoPackageFromId: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.onScheduleAvailabilityCheckClick = this.onScheduleAvailabilityCheckClick.bind(this);
    }

    render() {
        const { enrichedVideo, videoPackageFromId } = this.props;
        return (
            <div>
                <h3 className="mt0">{`Aired ${this.formattedLocalDateTime(enrichedVideo.airDate)}`}</h3>
                <ReactTable
                    columns={[
                        {
                            Header: "",
                            id: "scheduleAvailabilityCheck",
                            Cell: ({ row, original }) => (
                                <a href={original.countryCode + "/" + original.videoPackageId + "/" + original.platformId} onClick={this.onScheduleAvailabilityCheckClick}>
                                    <FontAwesomeIcon icon="ellipsis-h" />
                                </a>
                            ),
                            width: 30,
                            filterable: false,
                        },
                        {
                            Header: "Country",
                            accessor: "countryCode",
                        },
                        {
                            Header: "Platform",
                            id: "platformId",
                            accessor: d => platformFromId(d.platformId)
                        },
                        {
                            Header: "Package",
                            id: "videoPackageId",
                            accessor: d => videoPackageFromId(d.videoPackageId)
                        },
                        {
                            Header: "Channels",
                            Cell: ({ row, original }) => (
                                original.channels &&
                                <div>
                                    {original.channels.map(channel =>
                                        <span key={channel.channelTag}
                                              className="tooltipped badge bg-gray disabled"
                                              data-toggle="tooltip"
                                              title={`${original.channelNumbers[0]} ${channel.channelName} (${channel.channelTag})`}>
                                                            {/*<Img key={channel.images["logos"]["SMALL"]}*/}
                                                            {/*     className="channel-logo-table pr1"*/}
                                                            {/*     src={channel.images["logos"]["SMALL"]} />*/}
                                            <img key={channel.images["logos"]["SMALL"]}
                                                 className="channel-logo-table pr1"
                                                 alt="Channel logo"
                                                 src={channel.images["logos"]["SMALL"]} />
                                            {original.channelNumbers[0]}
                                                        </span>
                                    )}
                                </div>
                            ) || (
                                original.channelTags &&
                                <div>
                                    {original.channelTags.map((channelTag, idx) => {
                                        let channel = enrichedVideo.channels[channelTag];
                                        return <span key={channel.channelTag}
                                                     className="tooltipped badge bg-gray disabled"
                                                     data-toggle="tooltip"
                                                     title={`${original.channelNumbers[idx]} ${channel.channelName} (${channel.channelTag})`}>
                                                                   {/*<Img key={channel.images["logos"]["SMALL"]}*/}
                                            {/*     className="channel-logo-table pr1"*/}
                                            {/*     src={channel.images["logos"]["SMALL"]}/>*/}
                                            <img key={channel.images["logos"]["SMALL"]}
                                                 className="channel-logo-table pr1"
                                                 alt="Channel logo"
                                                 src={channel.images["logos"]["SMALL"]}/>
                                            {original.channelNumbers[idx]}
                                                               </span>
                                    })}
                                </div>
                            ),
                            filterable: false,
                        },
                        {
                            Header: "Start Date",
                            id: "startDateTime",
                            accessor: d => moment(d.startDateTime).local().format("YYYY-MM-DD HH:mm"),
                        },
                        {
                            Header: "Expiry Date",
                            id: "expiryDateTime",
                            accessor: d => moment(d.expiryDateTime).local().format("YYYY-MM-DD HH:mm"),
                        },
                    ]}
                    data={enrichedVideo.scheduling}
                    filterable
                    defaultFilterMethod={(filter, row) => {
                        console.log(filter);
                        return String(row[filter.id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
                    }}
                    className="-striped -highlight"
                    style={{
                        height: "450px",
                    }}
                />
            </div>
        )
    }

    onScheduleAvailabilityCheckClick(e) {
        e.preventDefault();

        const scheduleAvailabilityCheckApiPath = apiPath + "/enrichedVideos/scheduleAvailabilityCheck";
        const href = e.currentTarget.getAttribute("href").split("/");
        let params = {};
        params.enrichedVideoId = this.props.enrichedVideoId;
        params.countryCode = href[0];
        params.videoPackageId = href[1];
        params.platformId = href[2];
        const videoPackageFromId = this.props.videoPackageFromId;

        getRequest(
            scheduleAvailabilityCheckApiPath,
            params
        ).then(response => {
            response && this.props.alert.success(this.renderScheduleAvailabilityCheckResponse(response.entity, params.countryCode, params.videoPackageId, params.platformId, videoPackageFromId), {offset:"100px", timeout:60000});
        }).catch(response => {
            response && this.props.alert.error(`HTTP ${response.entity.status} - ${response.entity.error} : ${response.entity.message}`,
                                               {offset:"100px", timeout:3000});
        });
    }

    renderScheduleAvailabilityCheckResponse(response, countryCode, videoPackageId, platformId, videoPackageFromId) {
        console.log(response);
        return response &&
               ((response.programId && this.renderProgramScheduleAvailabilityCheckResponse(response, countryCode, videoPackageId, platformId, videoPackageFromId)) ||
                   this.renderVideoScheduleAvailabilityCheckResponse(response, countryCode, videoPackageId, platformId, videoPackageFromId));
    }

    formattedLocalDateTime(dateTime) {
        return (dateTime && moment(dateTime).local().format("YYYY-MM-DD HH:mm:ss")) || "Not Available";
    }

    renderProgramScheduleAvailabilityCheckResponse(response, countryCode, videoPackageId, platformId, videoPackageFromId) {
        return response &&
            <div>
                <h2>{countryCode} - {videoPackageFromId(videoPackageId)} - {platformFromId(platformId)} </h2>

                <Row className="mb2">
                    <Col sm="2">{""}</Col>
                    <Col sm="6"><strong>Service</strong></Col>
                    <Col sm="2"><strong>Program</strong></Col>
                    <Col sm="2"><strong>Video</strong></Col>
                </Row>
                {response.checks.map(check =>
                    <Row key={check.id} className="mb2">
                        <Col sm="1">
                            <a href={check.url} onClick={e => {
                                e.preventDefault();
                                navigator.clipboard.writeText(check.url);
                            }}>
                                <span className="tooltipped"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title={check.url}>
                                    <FontAwesomeIcon icon="copy"/>
                                </span>
                            </a>
                        </Col>
                        <Col sm="7">{check.id}</Col>
                        <Col sm="2">{(check.programAvailable && <FontAwesomeIcon icon="check-circle"/>) ||
                            <FontAwesomeIcon icon="ban"/>}</Col>
                        <Col sm="2">{(check.videoAvailable && <FontAwesomeIcon icon="check-circle"/>) ||
                            <FontAwesomeIcon icon="ban"/>}</Col>
                    </Row>
                )}
            </div>;
    }

    renderVideoScheduleAvailabilityCheckResponse(response, countryCode, videoPackageId, platformId, videoPackageFromId) {
        return response &&
            <div>
                <h2>{countryCode} - {videoPackageFromId(videoPackageId)} - {platformFromId(platformId)} </h2>

                <Row className="mb2">
                    <Col sm="2">{""}</Col>
                    <Col sm="6"><strong>Service</strong></Col>
                    <Col sm="4"><strong>Video</strong></Col>
                </Row>
                {response.checks.map(check =>
                    <Row key={check.id} className="mb2">
                        <Col sm="1">
                            <a href={check.url} onClick={e => {
                                e.preventDefault();
                                navigator.clipboard.writeText(check.url);
                            }}>
                                <span className="tooltipped"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title={check.url}>
                                    <FontAwesomeIcon icon="copy"/>
                                </span>
                            </a>
                        </Col>
                        <Col sm="7">{check.id}</Col>
                        <Col sm="4">{(check.videoAvailable && <FontAwesomeIcon icon="check-circle"/>) ||
                            <FontAwesomeIcon icon="ban"/>}</Col>
                    </Row>
                )}
            </div>;
    }
});

const VideoAssets = withAlert(class VideoAssets extends Component {

    static propTypes = {
        enrichedVideoId: PropTypes.string,
        enrichedVideo: PropTypes.object,
        videoAssets: PropTypes.arrayOf(PropTypes.object).isRequired,
        videoAssetFileMetaData: PropTypes.object,
        videoAssetProvisioningMetaData: PropTypes.object,
    };

    static defaultProps = {
        enrichedVideo: {},
        videoAssets: [],
        videoAssetFileMetaData: {},
        videoAssetProvisioningMetaData: {},
    };

    constructor(props) {
        super(props);

        this.onVideoAssetDebugClick = this.onVideoAssetDebugClick.bind(this);
        this.renderVideoAssetDebugResponse = this.renderVideoAssetDebugResponse.bind(this);
    }

    render() {
        const { enrichedVideo, videoAssets, videoAssetFileMetaData, videoAssetProvisioningMetaData } = this.props;
        return (
            <div>
                {videoAssets.map(videoAsset => this.renderVideoAsset(videoAsset, videoAssetFileMetaData[videoAsset.manItemId], videoAssetProvisioningMetaData[videoAsset.manItemId], enrichedVideo))}
            </div>
        )
    }

    renderVideoAsset(videoAsset, videoAssetFileMetaData, videoAssetProvisioningMetaData, enrichedVideo) {
        return videoAsset &&
               <div key={videoAsset.manItemId} className="well">
                   <h3 className="mt0">
                       { videoAsset.name != videoAsset.manItemId
                         ? `${videoAsset.manItemId} - ${videoAsset.name}`
                         : videoAsset.manItemId }
                   </h3>
                   <Row className="mb2">
                       <Col sm="2" xs="12">{this.renderVideoTypeIcon(videoAsset)} {videoAsset.videoQuality}</Col>
                       <Col sm="2" xs="12">{this.renderAudioTypeIcon(videoAsset)}</Col>
                       <Col sm="5" xs="12" className="text-right"><b>{NumberFormat(videoAsset.fileSizeInKiloBytes)}</b> KB</Col>
                       <Col sm="3" xs="12" className="text-right">
                           { enrichedVideo.durationInSeconds && enrichedVideo.durationInSeconds > 0 &&
                             <span className="badge bg-blue">{moment.utc(enrichedVideo.durationInSeconds*1000).format('HH:mm:ss')}</span> }
                       </Col>
                   </Row>
                   <Row className="mb2">
                       <Col md="8" xs="12">
                           { videoAsset.timeCodes && videoAsset.timeCodes.length > 0 &&
                             <div>
                                 { videoAsset.timeCodes.map(timeCode =>
                                     <Row key={timeCode.type} className="mb2">
                                         <Col sm="4" xs="12">{timeCodeLabelFromType(timeCode.type)}</Col>
                                         <Col sm="8" xs="12" className="text-right">
                                             <span className="badge bg-green">{moment.utc(timeCode.startOffsetSeconds*1000).format('HH:mm:ss')}</span>
                                             <span className="badge bg-blue">{moment.utc(timeCode.durationInSeconds*1000).format('HH:mm:ss')}</span>
                                             <span className="badge bg-red">{moment.utc(timeCode.endOffsetSeconds*1000).format('HH:mm:ss')}</span>
                                         </Col>
                                     </Row>
                                 )}
                             </div>
                           }
                       </Col>
                       <Col md="4" xs="12">
                           <div className="text-right">
                               { videoAsset.platformIds.map(platformId => {
                                   return (
                                       <span key={platformId}
                                             className="badge bg-aqua">
                                           {platformFromId(platformId)}
                                       </span>
                                   );
                               })}
                           </div>
                       </Col>
                   </Row>
                   <Row className="mb2">
                       <Col sm="11" xs="11" className="ellipsis"><FontAwesomeIcon icon="link" /> {videoAsset.url}</Col>
                       <Col sm="1" xs="1">
                           <a href={videoAsset.manItemId} onClick={this.onVideoAssetDebugClick}>
                               <FontAwesomeIcon icon="bug" />
                           </a>
                       </Col>
                   </Row>
                   <Row className="mb2">
                       <Col sm="12" xs="12">
                           <Violations violations={videoAsset.violations || []}/>
                       </Col>
                   </Row>
                   { videoAssetFileMetaData &&
                     <Row className="mb2">
                         <Col sm="12" xs="12">
                             <ExpandableBox icon="folder-open"
                                            header="Files"
                                            content={
                                 <div className="lazy-loaded">
                                 {
                                     this.renderVideoAssetFileMetaDataMessageAndDetails(videoAssetFileMetaData) || this.renderVideoAssetFileMetaDataListing(videoAssetFileMetaData)
                                 }
                                 </div>
                         } />
                         </Col>
                     </Row>
                   }
                   { videoAssetProvisioningMetaData &&
                       <Row className="mb2">
                           <Col sm="12" xs="12">
                               <ExpandableBox icon="cogs"
                                              header="Provisioning"
                                              content={
                                  <div className="lazy-loaded">
                                  {
                                      this.renderVideoAssetProvisioningMetaDataMessageAndDetails(videoAssetProvisioningMetaData) || this.renderVideoAssetProvisioningMetaDataListing(videoAssetProvisioningMetaData)
                                  }
                                  </div>
                              } />
                           </Col>
                       </Row>
                   }
               </div>
    }

    renderVideoAssetFileMetaDataMessageAndDetails(videoAssetFileMetaData) {
        return (videoAssetFileMetaData.message || (videoAssetFileMetaData.details && videoAssetFileMetaData.details.length > 0)) &&
               <div>
                   <div>{this.renderVideoAssetFileMetaDataMessage(videoAssetFileMetaData)}</div>
                   <div>{this.renderVideoAssetFileMetaDataDetails(videoAssetFileMetaData)}</div>
               </div>
    }

    renderVideoAssetFileMetaDataMessage(videoAssetFileMetaData) {
        return videoAssetFileMetaData.message &&
               <strong><p>{videoAssetFileMetaData.message}</p></strong>
    }

    renderVideoAssetFileMetaDataDetails(videoAssetFileMetaData) {
        return videoAssetFileMetaData.details && videoAssetFileMetaData.details.length > 0 &&
               <ul>{videoAssetFileMetaData.details.map((details, idx) => <li key={`details_${idx}`}>{`${details}`}</li>)}</ul>
    }

    renderVideoAssetFileMetaDataListing(videoAssetFileMetaData) {
        return videoAssetFileMetaData.listing && videoAssetFileMetaData.listing.length > 0 &&
               videoAssetFileMetaData.listing.map(listing => <Row key={listing.fileName}>
                                                                 <Col sm="7" xs="12">{listing.fileName}</Col>
                                                                 <Col sm="3" xs="12">{this.formattedLocalDateTime(listing.lastModified)}</Col>
                                                                 <Col sm="2" xs="12" className="text-right">{NumberFormat(listing.fileSizeInKiloBytes)} KB</Col>
                                                             </Row>)
    }

    renderVideoAssetProvisioningMetaDataMessageAndDetails(videoAssetProvisioningMetaData) {
        return (videoAssetProvisioningMetaData && videoAssetProvisioningMetaData.length > 0) &&
            <div>
                <ul>
                {videoAssetProvisioningMetaData.map((auditLog, idx) =>
                    <li key={`audit_log_${idx}`}>
                        <h4>{auditLog.clusterBaseUrl}</h4>
                        <ul>
                            <li><strong>Started : </strong> {this.formattedLocalDateTime(auditLog.created)}</li>
                            <li><strong>{auditLog.status == "Passed" || auditLog.status == "Failed" ? "Completed" : "Updated"} : </strong> {this.formattedLocalDateTime(auditLog.updated)}</li>
                            <li><strong>Status : </strong> {auditLog.status} { auditLog.message && <br /> } { auditLog.message }</li>
                            {auditLog.steps && auditLog.steps.length > 0 &&
                                <li><strong>Steps : </strong>
                                    <ul>
                                    {auditLog.steps.map((auditLogStep, sidx) =>
                                        <li key={`audit_log_step_${idx} _${sidx}`}>
                                            <strong>{auditLogStep.label ? auditLogStep.label : `Step ${sidx + 1}`} </strong> {auditLogStep.status}
                                            { auditLogStep.message && <br /> } { auditLogStep.message }
                                        </li>
                                    )}
                                    </ul>
                                </li>
                            }
                        </ul>
                    </li>
                )}
                </ul>
            </div>
    }

    renderVideoTypeIcon(videoAsset) {
        switch (videoAsset.type) {
            case "DOWNLOAD":
                return <span className="tooltipped" data-toggle="tooltip" title="Download">
                           <FontAwesomeIcon icon="download" />
                       </span>
            case "STREAMING":
                return <span className="tooltipped" data-toggle="tooltip" title="Streaming">
                           <FontAwesomeIcon icon="stream" />
                       </span>
            case "DOWNLOAD_AND_STREAMING":
                return <span className="tooltipped" data-toggle="tooltip" title="Download & Streaming">
                           <FontAwesomeIcon icon="download" />
                           <strong>&nbsp;&&nbsp;</strong>
                           <FontAwesomeIcon icon="stream" />
                       </span>
            default:
                return <FontAwesomeIcon icon="question-circle" />
        }
    }

    renderAudioTypeIcon(videoAsset) {
        switch (videoAsset.audioType) {
            case "Stereo":
                return <span className="tooltipped" data-toggle="tooltip" title="Stereo">
                           <Glyphicon glyph="sound-stereo"/>
                       </span>
            case "Dolby":
                return  <span className="tooltipped" data-toggle="tooltip" title="Dolby">
                           <Glyphicon glyph="sound-dolby"/>
                       </span>
            default:
                return <FontAwesomeIcon icon="question-circle" />
        }
    }

    formattedLocalDateTime(dateTime) {
        return (dateTime && moment(dateTime).local().format("YYYY-MM-DD HH:mm:ss")) || "Not Available";
    }

    onVideoAssetDebugClick(e) {
        e.preventDefault();

        const debugApiPath = apiPath + "/enrichedVideos/debugVideoAsset";
        let params = {};
        params.enrichedVideoId = this.props.enrichedVideoId;
        params.videoAssetManItemId = e.currentTarget.getAttribute("href");

        getRequest(
            debugApiPath,
            params
        ).then(response => {
            response && this.props.alert.success(this.renderVideoAssetDebugResponse(response.entity), {offset:"100px", timeout:60000});
        }).catch(response => {
            response && this.props.alert.error(`HTTP ${response.entity.status} - ${response.entity.error} : ${response.entity.message}`,
                                               {offset:"100px", timeout:3000});
        });
    }

    renderVideoAssetDebugResponse(response) {
        return response &&
               <div>
                   <h2>{response.status}</h2>
                   <h3>{response.statusMessage}</h3>
                   {(response.logs && response.logs.length > 0) && <pre>{response.logs.join('\n\n')}</pre>}
               </div>
    }

});

class Violations extends Component {

    static propTypes = {
        violations: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {violations} = this.props;
        return (
            <div>
                {violations.map((violation, idx) => {
                    return <Callout key={`${violation.validation}_${idx}`}
                                    level={this.renderViolationCalloutLevel(violation.level)}
                                    icon={this.renderViolationCalloutIcon(violation.level)}
                                    header={violation.validation}
                                    content={
                                        <div>
                                            <p>{violation.message}</p>
                                            <div className="text-right">
                                                {violation.platformIds.map(platformId => {
                                                    return (
                                                        <span key={platformId}
                                                              className={`badge bg-${this.renderViolationCalloutBadgeBgColor(violation.level)}`}>
                                                            {platformFromId(platformId)}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                     }
                                     />
                })}
            </div>
        )
    }

    renderViolationCalloutLevel(level) {
        switch(level) {
            case 'WARNING':
                return "warning";
            case 'INFO':
                return "info";
            case 'UNKNOWN':
                return "muted";
            case 'ERROR':
            default:
                return "danger";
        }
    }

    renderViolationCalloutBadgeBgColor(level) {
        switch(level) {
            case 'WARNING':
                return "yellow-active";
            case 'INFO':
                return "aqua-active";
            case 'UNKNOWN':
                return "gray-active";
            case 'ERROR':
            default:
                return "red-active";
        }
    }

    renderViolationCalloutIcon(level) {
        switch(level) {
            case 'WARNING':
                return "exclamation-triangle";
            case 'INFO':
                return "info-circle";
            case 'UNKNOWN':
                return "question-circle";
            case 'ERROR':
            default:
                return "ban";
        }
    }
}


export default EnrichedVideoWidget;
